<script setup lang="ts">
import { computed, useAttrs } from 'vue';

// PROPS
const props = defineProps<{
  color?: string;
  iconColor?: string;
  icon?: string;
  iconLeft?: boolean;
  iconRight?: boolean;
}>();

const attrs = useAttrs();

const isInteractive = computed(() => typeof attrs.onClick === 'function');
</script>
<template>
  <component
    :is="isInteractive ? 'button' : 'div'"
    class="base-tag"
    :class="props.color"
    :type="isInteractive ? 'button' : undefined"
  >
    <q-icon class="base-tag__icon" v-if="props.icon && props.iconLeft" :color="props.iconColor" :name="props.icon" />
    <slot name="title"></slot>
    <q-icon class="base-tag__icon" v-if="props.icon && props.iconRight" :color="props.iconColor" :name="props.icon" />
    <slot name="number"></slot>
  </component>
</template>

<style lang="scss">
.base-tag {
  align-items: center;
  border: 0;
  background-color: $color-primary-12;
  border-radius: 4px;
  color: $color-neutral-black;
  cursor: default;
  display: flex;
  font-size: $small-text;
  min-height: 20px;
  margin: 0;
  outline: none;
  padding: 0 $space-xs;
  text-align: left;
  text-decoration: none;
  width: fit-content;

  &[type='button'] {
    cursor: pointer;
  }

  &[type='button']:focus-visible {
    box-shadow:
      0 0 0 2px $color-neutral-white,
      0 0 0 4px var(--q-primary);
  }

  &__icon {
    font-size: $body-text;
    padding-right: $space-xs;
  }

  &.green,
  .agree {
    background: $color-green-12;
  }

  &.red,
  .disagree {
    background: $color-red-12;
  }

  &.blue {
    background: $color-primary-darken;
  }

  &.orange {
    background: $color-orange-12;
  }

  &.grey {
    background: $color-neutral-grey-200;
    color: $color-neutral-grey-400;
  }

  &.grey-disable {
    background: $color-neutral-grey-100;
    color: $color-neutral-grey-400-50;
  }
  &.white {
    background: $color-neutral-white;
    color: $color-primary-darken;
  }
  &.grey-blue {
    background: $color-neutral-grey-200;
    color: $color-primary-darken;
  }

  &.blue-grey {
    color: $color-neutral-white;
    background-color: $color-primary-darken;
  }

  &.transparent {
    background-color: transparent;
  }
}
</style>
